module.exports = __webpack_public_path__ + "static/media/thimble_clevis.3a6a0577.webp";